<script setup lang="ts">
  import { FieldTypeEnum } from '@/types/generated'
  import UniqueTableDataCell from '@/components/admin/table/UniqueTableDataCell.vue'
  import { TableCell } from '@/components/ui/table'
  import { type CustomerDataMapper as DataMapper } from '@/types/generated/types.gen'
  import { defineProps, type PropType } from 'vue'
  import InfoButton from '@/components/app/cases/infoButton.vue'

  const props = defineProps({
    mapper: {
      type: Object as PropType<DataMapper>,
      required: true
    }
  })

  function formatDate(date: Date): string {
    return new Intl.DateTimeFormat('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(date)
  }
</script>
<template>
  <template v-if="mapper.data">
    <div class="flex w-full items-center gap-2">
      <div class="flex-grow">
        <UniqueTableDataCell
          class="ps-0"
          :truncate="false"
        >
          <div v-if="mapper.data">
            <template v-if="mapper.field_type === FieldTypeEnum.FILEFIELD && mapper.data">
              <a
                :href="mapper.data.file"
                target="_blank"
              >
                {{ mapper.data }}
              </a>
            </template>
            <template v-else-if="mapper.field_type === FieldTypeEnum.DATEFIELD">
              {{ formatDate(new Date(mapper.data)) }}
            </template>
            <template v-else-if="mapper.field_type === FieldTypeEnum.YESNO">
              <template v-if="mapper.data == 'True'">Ja</template>
              <template v-else>Nein</template>
            </template>
            <template v-else>
              {{ mapper.data }}
            </template>
          </div>
        </UniqueTableDataCell>
      </div>
      <InfoButton
        v-if="mapper?.latest_change?.ai_augmentation?.explanation"
        :explanation="mapper.latest_change.ai_augmentation.explanation"
        :id="mapper.latest_change.ai_augmentation.uuid"
      />
    </div>
  </template>
  <template v-else>
    <TableCell></TableCell>
  </template>
</template>
